import { render, staticRenderFns } from "./chat-attached-pdf-document.vue?vue&type=template&id=18c8ac6e&scoped=true"
import script from "./chat-attached-pdf-document.vue?vue&type=script&lang=js"
export * from "./chat-attached-pdf-document.vue?vue&type=script&lang=js"
import style0 from "./chat-attached-pdf-document.vue?vue&type=style&index=0&id=18c8ac6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8ac6e",
  null
  
)

export default component.exports